<template>
	<div class="blackMenu_box">
		<div class="blackMenu">
			<div class="search_box">
				<div class="box_line">
					<div class="line_input">
						<div class="input_title">人员姓名</div>
						<input type="text" class="input_box" placeholder="请输入人员姓名" v-model="searchName" />
					</div>
					<div class="line_input">
						<div class="input_title">身份证号</div>
						<input type="text" class="input_box" placeholder="请输入身份证号" v-model="searchId" />
					</div>
					<div class="line_input">
						<div class="input_title">是否有效</div>
						<el-select size="small" class="select_box" v-model="searchStatus" :popper-append-to-body="false" filterable placeholder="请选择" style="border-radius: 0;">
							<el-option label="请选择" value></el-option>
							<el-option label="已过期" value="1">已过期</el-option>
							<el-option label="未过期" value="0">未过期</el-option>
						</el-select>
					</div>
					<div class="search-btn" @click="fnSearch"><span>搜索</span></div>
					<div class="search-btn orange" @click="fnOpenBlackWin('add')"><span>新增黑名单</span></div>
				</div>
			</div>
			<div class="cont_list">
				<div class="list_title">
					<div class="title_item">姓名</div>
					<div class="title_item">人员照片</div>
					<div class="title_item">性别</div>
					<div class="title_item">身份证号</div>
					<div class="title_item">项目名称</div>
					<div class="title_item">班组</div>
					<div class="title_item">工种</div>
					<div class="title_item">联系电话</div>
					<div class="title_item">原因</div>
					<div class="title_item">创建时间</div>
					<div class="title_item">操作</div>
				</div>
				<div class="list_boxes">
					<div class="list_box">
						<div v-if="tableData">
							<div class="box_line" v-for="(item, index) in tableData" :key="index">
								<div class="list_item">{{ item.name }}</div>
								<div class="list_item"><img :src="item.photo || 'http://cqzgzl.oss-cn-chengdu.aliyuncs.com/image/40fd31b9434de0d6cc965f1c2b475368.jpg'" /></div>
								<div class="list_item">{{ item.sex == '1' ? '男' : '女' }}</div>
								<div class="list_item">{{ item.idcard }}</div>
								<div class="list_item" :title="item.proname"><span>{{ item.proname }}</span></div>
								<div class="list_item" :title="fnTeamFormat(item.department)"><span>{{ fnTeamFormat(item.department) }}</span></div>
								<div class="list_item" :title="fnTeamFormat(item.position)"><span>{{ fnTeamFormat(item.position) }}</span></div>
								<div class="list_item">{{ item.phone }}</div>
								<div class="list_item" :title="item.reason"><span>{{ item.reason }}</span></div>
								<div class="list_item">{{ item.create_at }}</div>
								<div class="list_item">
									<div>
										<div class="search-btn orange" @click="fnOpenBlackWin(item)"><span>编辑</span></div>
										<div class="search-btn red" @click="fnDelete(item)"><span>删除</span></div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="cont_page">
				<el-pagination
					background
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:page-sizes="pageSizes"
					:page-size="pageSize"
					:current-page="currentPage"
					layout="total, sizes, prev, pager, next, jumper"
					:total="pageTotal"
				/>
			</div>

			<!-- 新增黑名单弹窗 -->
			<div class="dialog_addBlack" v-if="isAddBlackMenu">
				<el-dialog :custom-class="'animate__animated animate__fadeIn'" :modal="false" title="添加黑名单" :visible.sync="isAddBlackMenu" center>
					<div class="black_boxes">
						<div class="black_box">
							<div class="black_line">
								<div class="line_input">
									<div class="input_title">人员姓名</div>
									<input type="text" class="input_box" :disabled="blackForm.id" placeholder="请输入人员姓名" v-model="selectName" @input="fnSearchSame"/>
								</div>
							</div>
							<div class="cont_list">
								<div class="list_title">
									<div class="title_item"></div>
									<div class="title_item">姓名</div>
									<div class="title_item">身份证照</div>
									<div class="title_item">性别</div>
									<div class="title_item">身份证号</div>
									<div class="title_item">班组</div>
									<div class="title_item">工种</div>
								</div>
								<div class="list_boxes">
									<div class="list_box">
										<div v-if="personList">
											<div class="box_line" v-for="(item, index) in personList" :key="index">
												<div class="list_item"><div class="select" @click="fnSelectBlackMenu(index)" :class="item.selected ? 'active' : ''"></div></div>
												<div class="list_item">{{ item.name }}</div>
												<div class="list_item"><img :src="item.photo || 'http://cqzgzl.oss-cn-chengdu.aliyuncs.com/image/40fd31b9434de0d6cc965f1c2b475368.jpg'" /></div>
												<div class="list_item">{{ item.sex == 1 ? '男' : '女' }}</div>
												<div class="list_item">{{ item.idcard }}</div>
												<div class="list_item" :title="fnTeamFormat(item.department)">
													<span>{{ fnTeamFormat(item.department) }}</span>
												</div>
												<div class="list_item" :title="fnTeamFormat(item.position)">
													<span>{{ fnTeamFormat(item.position) }}</span>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="black_line_reason">
								<div class="line_input">
									<div class="input_title">加入原因</div>
									<input type="text" class="input_box reason_box" placeholder="请输入原因" v-model="blackForm.reason" />
								</div>
							</div>
							<div class="black_line">
								<div class="line_input">
									<div class="input_title">时效性</div>
									<el-select size="small" class="select_box" v-model="blackForm.period" :popper-append-to-body="false" filterable placeholder="请选择" style="border-radius: 0;">
										<el-option label="请选择" value></el-option>
										<el-option label="12个月" value="12">12个月</el-option>
										<el-option label="24个月" value="24">24个月</el-option>
										<el-option label="60个月" value="60">60个月</el-option>
										<el-option label="永久" value="永久">永久</el-option>
									</el-select>
								</div>
							</div>
							<div class="black_line_img">
								<div class="input_title">附件</div>
								<el-upload
									class="avatar-uploader"
									action=""
									list-type="picture-card"
									:before-upload="res => { beforeCardPicUpload(res, 'img'); }"
									:show-file-list="false"
								>
									<img v-if="blackForm.img" :src="blackForm.img" class="avatar" />
									<i v-else class="el-icon-plus avatar-uploader-icon"></i>
								</el-upload>
							</div>
						</div>
					</div>
					<div slot="footer" class="dialog-footer" align="center">
						<div class="btn_line">
							<div class="search-btn red" @click="isAddBlackMenu = false"><span>取消</span></div>
							<div class="search-btn" @click="fnAddBlackMenu"><span>保存</span></div>
						</div>
					</div>
				</el-dialog>
			</div>
		</div>
	</div>
</template>

<script>
import APP from '@/utils/base';
import request from '@/utils/request';
import Cookies from 'js-cookie';
import { getUserInfo } from '@/utils/auth';
import { fnUpload } from '@/utils/upload';
import { Loading } from 'element-ui';
import * as imageConversion from 'image-conversion';
export default {
	data() {
		return {
			// 分页
			pageSize: APP.PAGE.LIMIT,
			pageSizes: APP.PAGE.SIZE_OPTION,
			currentPage: APP.PAGE.SKIP_PAGE,
			pageTotal: 0,
			// 搜索
			userInfo: null, // 登录账户信息
			searchName: '', // 人员姓名搜索
			searchId: '', // 身份证号搜索
			searchStatus: '', // 人员是否有效搜索

			tableData: [], // 页面列表
			isAddBlackMenu: false, // 新增黑名单弹窗
			personList: [], // 人员列表
			personListAll: [], // 人员列表搜索备份
			blackForm: {
				personnel_id: '', // 人员id
				period: '', // 时效性
				reason: '', // 原因
				img: '', // 附件照片
			},
			selectName: ''// 选择的人员姓名
		};
	},
	created() {
		this.fnInit();
		this.fnGetPerName();
	},
	methods: {
		// 分页选择
		handleSizeChange(val) {
			this.pageSize = val;
			this.fnSearch();
		},
		// 分页跳转
		handleCurrentChange(val) {
			this.currentPage = val;
			this.fnSearch();
		},
		fnInit() {
			this.fnGetBlackList(
				{
					page: this.currentPage,
					size: this.pageSize
				},
				res => {
					this.tableData = res.data.query;
					this.pageTotal = res.data.count;
				}
			);
		},
		// 获取所有黑名单人员列表
		fnGetBlackList(_obj, _cb) {
			request({
				url: 'blacklist/lists',
				method: 'GET',
				params: _obj
			})
				.then(res => {
					_cb && _cb(res);
				})
				.catch(err => {
					this.$message.error(err.data);
				});
		},
		// 搜索
		fnSearch(_isInit) {
			this.fnGetBlackList(
				{
					page: _isInit ? 1 : this.currentPage,
					size: this.pageSize,
					name: this.searchName,
					idcard: this.searchId,
					status: this.searchStatus
				},
				res => {
					this.tableData = res.data.query;
					this.pageTotal = res.data.count;
				}
			);
		},
		// 删除
		fnDelete(_data) {
			request({
				url: 'blacklist/delete',
				method: 'POST',
				data: {
					id: _data.id
				}
			})
				.then(res => {
					this.$message.success(res.data);
					this.fnSearch();
				})
				.catch(err => {
					this.$message.error(err.data);
				});
		},
		// 获取所有人员姓名
		fnGetPerName() {
			request({
				url: 'personnel/getAllPersonnel',
				method: 'GET',
				params:{
					type: 1
				}
			})
				.then(res => {
					let _data = res.data;
					for (var i in _data) {
						_data[i].selected = false;
					}
                    console.log(_data);
					this.personList = _data;
					this.personListAll = _data
				})
				.catch(err => {
					this.$message.error(err.data);
				});
		},
		// 打开新增黑名单弹窗
		fnOpenBlackWin(_data) {
			for(var i in this.personList){
				this.personList[i].selected = false
			}
			this.selectName = ''
			if(_data == 'add'){
				this.blackForm.personnel_id = '';
				this.blackForm.period = '';
				this.blackForm.reason = '';
				this.blackForm.img = '';
			}else{
				this.blackForm.personnel_id = _data.id
				this.blackForm.period = _data.period
				this.blackForm.reason = _data.reason
				this.blackForm.img = _data.img
				this.blackForm.id = _data.id
			}
			this.isAddBlackMenu = true;
		},
		// 搜索可匹配项目
		fnSearchSame(){
			this.personList = this.personListAll.filter(data => !this.selectName || data.name.toLowerCase().includes(this.selectName.toLowerCase()))
		},
		// 单个选择
		fnSelectBlackMenu(_index) {
			if(this.blackForm.id) return this.$message.warning("编辑时人员不能修改！");
			for (let i = 0; i < this.personList.length; i++) {
				if (i == _index) {
					this.personList[i].selected = true
					this.blackForm.personnel_id = this.personList[i].id
					this.selectName = this.personList[i].name
				}else{
					this.personList[i].selected = false
				}
			}
		},
		// 上传附件
		beforeCardPicUpload(_file, _el) {
			let _loadingInstance = Loading.service({
				fullscreen: true,
				background: 'rgba(255,255,255,0.7)',
				spinner: 'el-icon-loading',
				text: _el == 'photo' ? '人脸验证中…' : '图片上传中'
			});
			let _that = this;
			imageConversion.compressAccurately(_file, 200).then(_res => {
				let reader = new FileReader();
				reader.onload = function() {
					let _base64 = this.result;
					// base64转文件流对象
					let _fileObject = APP.fnBase64ToFile(_base64);
					let formData = new FormData();
					formData.append('file', _fileObject);
					formData.append('type', 'image');
					if (_base64.indexOf('data:image/') != -1) {
						_base64 = _base64.split(',')[1];
					}
					fnUpload(formData, res => {
						_that.blackForm[_el] = res.data.file_url;
						_loadingInstance.close();
					});
				};
				reader.readAsDataURL(_res);
			});
			return false; // 阻止组件自动上传图片
		},
		// 新增黑名单
		fnAddBlackMenu() {
			if(this.blackForm.personnel_id==''){
				return this.$message.warning("请选择加入黑名单的人员！");
			}
			if(this.blackForm.reason==''){
				return this.$message.warning("请填写加入黑名单的原因！");
			}
			if(this.blackForm.period==''){
				return this.$message.warning("请选择加入黑名单的时效！");
			}
			let _url = this.blackForm.id ? 'blacklist/edit':'blacklist/add'
			let _obj = {
				personnel_id: this.blackForm.personnel_id, // 人员id
				period: this.blackForm.period, // 时效性
				reason: this.blackForm.reason, // 原因
				img: this.blackForm.img // 附件照片
			}
			let _id = this.blackForm.id ? this.blackForm.id : ''
			if(_id){
				_obj.id = _id
			}
			request({
				url: _url,
				method: 'POST',
				data: _obj
			})
				.then(res => {
					this.$message.success(res.data);
					this.isAddBlackMenu = false
				})
				.catch(err => {
					this.$message.error(err.data);
				});

		},
		// 班组格式化 去除 #
		fnTeamFormat(_name) {
			return APP.fnTeamFormat(_name);
		}
	}
};
</script>

<style lang="scss" scoped>
@import '@/styles/mixin.scss';
.blackMenu_box {
	width: 1920px;
	height: 858px;
	position: relative;
	overflow: hidden;
	.blackMenu {
		position: absolute;
		left: 0;
		right: -20px;
		top: 0;
		bottom: 0;
		overflow-x: hidden;
		overflow-y: auto;
	}
}
.search_box {
	height: 32px;
	width: 1880px;
	margin-top: 24px;
	margin-left: 20px;
	@include flex-box(space-between, center, column);
	.box_line {
		width: 1880px;
		height: 32px;
		@include flex-box(flex-start, center);
		.line_input {
			min-width: 280px;
			height: 30px;
			margin-right: 10px;
			border-top-right-radius: 1px;
			border-bottom-right-radius: 1px;
			background-color: rgba(49, 88, 128, 0.4);
			@include flex-box(flex-start, center);
			.input_title {
				width: 69px;
				height: 30px;
				font-size: 14px;
				color: #9bf9fc;
				border-radius: 2px;
				background-color: rgba(155, 249, 252, 0.1);
				@include flex-box(center, center);
			}
			.input_box {
				width: 211px;
				height: 30px;
				line-height: 30px;
				padding-left: 15px;
				color: rgba(77, 180, 244, 0.7);
				font-size: 12px;
				border-radius: 2px;
				outline: none;
				background: transparent;
				border: none;
				&::-webkit-input-placeholder {
					color: rgba(77, 180, 244, 0.7);
				}
				&::-moz-placeholder {
					/* Mozilla Firefox 19+ */
					color: rgba(77, 180, 244, 0.7);
				}
				&:-moz-placeholder {
					/* Mozilla Firefox 4 to 18 */
					color: rgba(77, 180, 244, 0.7);
				}
				&:-ms-input-placeholder {
					/* Internet Explorer 10-11 */
					color: rgba(77, 180, 244, 0.7);
				}
			}
			.select_box {
				width: 211px;
				height: 30px;
				border-radius: 2px;
			}
		}
	}
}
.cont_list {
	margin-top: 29px;
	margin-left: 28px;
	width: 1864px;
	height: 677px;
	border-radius: 10px;
	background-color: rgba(29, 68, 149, 0.1);
	.list_title {
		width: 1864px;
		height: 48px;
		background: url(../../../assets/img/per_list_bg.png) no-repeat;
		background-size: 100% 100%;
		@include flex-box(flex-start, center);
		.title_item {
			height: 48px;
			@include flex-box(center, center);
			&:nth-child(1) {
				width: 114px;
				margin: 0 4px 0 40px;
			}
			&:nth-child(2) {
				width: 116px;
				margin-right: 4px;
			}
			&:nth-child(3) {
				width: 116px;
				margin-right: 4px;
			}
			&:nth-child(4) {
				width: 186px;
				margin-right: 4px;
			}
			&:nth-child(5) {
				width: 186px;
				margin-right: 4px;
			}
			&:nth-child(6) {
				width: 146px;
				margin-right: 4px;
			}
			&:nth-child(7) {
				width: 146px;
				margin-right: 4px;
			}
			&:nth-child(8) {
				width: 146px;
				margin-right: 4px;
			}
			&:nth-child(9) {
				width: 236px;
				margin-right: 4px;
			}
			&:nth-child(10) {
				width: 166px;
				margin-right: 4px;
			}
			&:nth-child(11) {
				width: 186px;
				margin-right: 40px;
			}
		}
	}
	.list_boxes {
		width: 1864px;
		height: 629px;
		position: relative;
		overflow: hidden;
		.list_box {
			position: absolute;
			left: 0;
			right: -25px;
			top: 0;
			bottom: 0;
			overflow-x: hidden;
			overflow-y: auto;
			.box_line {
				width: 1784px;
				height: 70px;
				margin: 7px 0 0 40px;
				font-size: 16px;
				color: #ffffff;
				border-bottom: 1px dashed #1d4495;
				@include flex-box(flex-start, center);
				&:hover{
					background-color: rgba(49, 88, 128, 0.4);
				}
				.list_item {
					height: 70px;
					text-align: center;
					@include flex-box(center, center);
					&:nth-child(1) {
						width: 114px;
						margin-right: 4px;
					}
					&:nth-child(2) {
						width: 116px;
						margin-right: 4px;
					}
					&:nth-child(3) {
						width: 116px;
						margin-right: 4px;
					}
					&:nth-child(4) {
						width: 186px;
						margin-right: 4px;
					}
					&:nth-child(5) {
						width: 186px;
						margin-right: 4px;
					}
					&:nth-child(6) {
						width: 146px;
						margin-right: 4px;
					}
					&:nth-child(7) {
						width: 146px;
						margin-right: 4px;
					}
					&:nth-child(8) {
						width: 146px;
						margin-right: 4px;
					}
					&:nth-child(9) {
						width: 236px;
						margin-right: 4px;
					}
					&:nth-child(10) {
						width: 166px;
						margin-right: 4px;
					}
					&:nth-child(11) {
						width: 186px;
					}
					img {
						width: 40px;
						height: 40px;
						border-radius: 50%;
					}
					div {
						@include flex-box(center, center);
						// .item_btn {
						// 	width: 69px;
						// 	height: 32px;
						// 	line-height: 32px;
						// 	margin: 0 2px;
						// 	font-size: 14px;
						// 	color: #ffffff;
						// 	border: none;
						// 	cursor: pointer;
						// 	background: url(../../../assets/img/btn_bg_rsm.png) no-repeat;
						// 	background-size: 100% 100%;
						// 	@include flex-box(center, center);
						// 	span {
						// 		margin-top: -2px;
						// 	}
						// 	&.orange{
						// 		background: url(../../../assets/img/btn_bg_osm.png) no-repeat;
						// 		background-size: 100% 100%;
						// 	}
						// }
					}
				}
			}
		}
	}
}
.box_line {
	>>> .el-input__inner {
		width: 211px;
		height: 30px;
		border-radius: 2px;
		border: none;
		color: rgba(77, 180, 244, 0.7);
		background: transparent;
		&::-webkit-input-placeholder {
			color: rgba(77, 180, 244, 0.7);
		}
		&::-moz-placeholder {
			/* Mozilla Firefox 19+ */
			color: rgba(77, 180, 244, 0.7);
		}
		&:-moz-placeholder {
			/* Mozilla Firefox 4 to 18 */
			color: rgba(77, 180, 244, 0.7);
		}
		&:-ms-input-placeholder {
			/* Internet Explorer 10-11 */
			color: rgba(77, 180, 244, 0.7);
		}
	}
	>>> .el-select__caret {
		color: rgba(77, 180, 244, 0.7);
	}
	>>> .el-select-dropdown {
		background-color: rgba(77, 180, 244, 0.2);
		border: 1px solid rgba(77, 180, 244, 1);
	}
	>>> .popper__arrow {
		border-bottom-color: rgba(77, 180, 244, 1) !important;
	}
	>>> .el-select-dropdown__item {
		color: rgba(77, 180, 244, 0.7);
	}
	>>> .el-select-dropdown__item:hover {
		color: #409eff;
	}
	>>> .el-select-dropdown__item.hover {
		color: #409eff;
	}
	>>> .el-input__icon {
		color: rgba(77, 180, 244, 0.7);
	}
}

// 弹窗样式
.dialog_addBlack {
	.btn_line {
		@include flex-box(center, center);
	}
	>>> .el-dialog {
		width: 1200px;
		height: 750px;
		margin-top: 15vh !important;
		background-color: rgba(9, 17, 32, 1);
		border: 1px solid rgba(58, 116, 221, 1);
	}
	>>> .el-form-item__label {
		color: #4db4f4;
	}
	>>> .el-dialog__title {
		color: #4db4f4;
	}
	>>> .el-dialog__close {
		color: #4db4f4;
	}
	.black_boxes{
		width: 1140px;
		height: 580px;
		position: relative;
		overflow: hidden;
		.black_box{
			position: absolute;
			left: 0;
			right: -25px;
			top: 0;
			bottom: 0;
			overflow-x: hidden;
			overflow-y: auto;
			.black_line {
				margin-bottom: 10px;
				width: 1140px;
				min-height: 32px;
				@include flex-box(flex-start, center);
				.line_input {
					width: 360px;
					height: 30px;
					margin-right: 10px;
					border-top-right-radius: 1px;
					border-bottom-right-radius: 1px;
					background-color: rgba(49, 88, 128, 0.4);
					@include flex-box(flex-start, center);
					.input_title {
						width: 80px;
						height: 30px;
						font-size: 14px;
						color: #9bf9fc;
						border-radius: 2px;
						background-color: rgba(155, 249, 252, 0.1);
						@include flex-box(center, center);
					}
					.input_box {
						width: 280px;
						height: 30px;
						line-height: 30px;
						padding-left: 15px;
						color: rgba(77, 180, 244, 0.7);
						font-size: 12px;
						border-radius: 2px;
						outline: none;
						background: transparent;
						border: none;
						&::-webkit-input-placeholder {
							color: rgba(77, 180, 244, 0.7);
						}
						&::-moz-placeholder {
							/* Mozilla Firefox 19+ */
							color: rgba(77, 180, 244, 0.7);
						}
						&:-moz-placeholder {
							/* Mozilla Firefox 4 to 18 */
							color: rgba(77, 180, 244, 0.7);
						}
						&:-ms-input-placeholder {
							/* Internet Explorer 10-11 */
							color: rgba(77, 180, 244, 0.7);
						}
					}
					.select_box {
						width: 280px;
						height: 30px;
						border-radius: 2px;
					}
					>>> .el-input__inner {
						width: 280px;
						height: 30px;
						border-radius: 2px;
						border: none;
						color: rgba(77, 180, 244, 0.7);
						background: transparent;
						&::-webkit-input-placeholder {
							color: rgba(77, 180, 244, 0.7);
						}
						&::-moz-placeholder {
							/* Mozilla Firefox 19+ */
							color: rgba(77, 180, 244, 0.7);
						}
						&:-moz-placeholder {
							/* Mozilla Firefox 4 to 18 */
							color: rgba(77, 180, 244, 0.7);
						}
						&:-ms-input-placeholder {
							/* Internet Explorer 10-11 */
							color: rgba(77, 180, 244, 0.7);
						}
					}
					>>> .el-select__caret {
						color: rgba(77, 180, 244, 0.7);
					}
				}
			}
			.black_line_reason{
				margin-bottom: 10px;
				width: 1140px;
				min-height: 32px;
				@include flex-box(flex-start, center);
				.line_input {
					width: 680px;
					height: 30px;
					margin-right: 10px;
					border-top-right-radius: 1px;
					border-bottom-right-radius: 1px;
					background-color: rgba(49, 88, 128, 0.4);
					@include flex-box(flex-start, center);
					.input_title {
						width: 80px;
						height: 30px;
						font-size: 14px;
						color: #9bf9fc;
						border-radius: 2px;
						background-color: rgba(155, 249, 252, 0.1);
						@include flex-box(center, center);
					}
					.input_box {
						width: 600px;
						height: 30px;
						line-height: 30px;
						padding-left: 15px;
						color: rgba(77, 180, 244, 0.7);
						font-size: 12px;
						border-radius: 2px;
						outline: none;
						background: transparent;
						border: none;
						&::-webkit-input-placeholder {
							color: rgba(77, 180, 244, 0.7);
						}
						&::-moz-placeholder {
							/* Mozilla Firefox 19+ */
							color: rgba(77, 180, 244, 0.7);
						}
						&:-moz-placeholder {
							/* Mozilla Firefox 4 to 18 */
							color: rgba(77, 180, 244, 0.7);
						}
						&:-ms-input-placeholder {
							/* Internet Explorer 10-11 */
							color: rgba(77, 180, 244, 0.7);
						}
					}
					>>> .el-input__inner {
						width: 600px;
						height: 30px;
						border-radius: 2px;
						border: none;
						color: rgba(77, 180, 244, 0.7);
						background: transparent;
						&::-webkit-input-placeholder {
							color: rgba(77, 180, 244, 0.7);
						}
						&::-moz-placeholder {
							/* Mozilla Firefox 19+ */
							color: rgba(77, 180, 244, 0.7);
						}
						&:-moz-placeholder {
							/* Mozilla Firefox 4 to 18 */
							color: rgba(77, 180, 244, 0.7);
						}
						&:-ms-input-placeholder {
							/* Internet Explorer 10-11 */
							color: rgba(77, 180, 244, 0.7);
						}
					}
				}
			}
			.black_line_img{
				width: 1140px;
				height: 120px;
				@include flex-box(flex-start,center);
				.input_title {
					width: 80px;
					height: 30px;
					font-size: 14px;
					color: #9bf9fc;
					margin-right: 30px;
					border-radius: 2px;
					background-color: rgba(37, 65, 88, 1);
					@include flex-box(center, center);
				}
				>>>.avatar-uploader {
					line-height: 100px;
					margin-right: 10px;
					img {
						width: 98px;
						height: 98px;
						border-radius: 2px;
					}
				}
				>>>.el-upload {
					width: 100px;
					height: 100px;
					line-height: 100px;
				}
				// 上传图片样式
				>>>.el-upload--picture-card{
					background-color: rgba(9, 17, 32, 0.5);
				}
			}
			.cont_list {
				width: 1140px;
				height: 305px;
				color: #ffffff;
				font-size: 16px;
				border-radius: 10px;
				margin: 0 0 20px 0;
				background-color: rgba(29, 68, 149, 0.1);
				.list_title {
					width: 1140px;
					height: 48px;
					background: url(../../../assets/img/per_list_bg.png) no-repeat;
					background-size: 100% 100%;
					@include flex-box(flex-start, center);
					.title_item {
						height: 48px;
						@include flex-box(center, center);
						&:nth-child(1) {
							width: 62px;
							margin-right: 2px;
							margin-left: 30px;
						}
						&:nth-child(2) {
							width: 175px;
							margin: 0 2px;
						}
						&:nth-child(3) {
							width: 175px;
							margin: 0 2px;
						}
						&:nth-child(4) {
							width: 145px;
							margin: 0 2px;
						}
						&:nth-child(5) {
							width: 206px;
							margin: 0 2px;
						}
						&:nth-child(6) {
							width: 176px;
							margin: 0 2px;
						}
						&:nth-child(7) {
							width: 175px;
							margin-left: 2px;
							margin-right: 30px;
						}
					}
				}
				.list_boxes {
					width: 1080px;
					height: 257px;
					margin-left: 30px;
					position: relative;
					overflow: hidden;
					.list_box {
						position: absolute;
						left: 0;
						right: -25px;
						top: 0;
						bottom: 0;
						overflow-x: hidden;
						overflow-y: auto;
						.box_line {
							width: 1080px;
							height: 70px;
							margin: 5px 0 0 0px;
							border-bottom: 1px dashed #1d4495;
							@include flex-box(flex-start, center);
							&:hover{
								background-color: rgba(49, 88, 128, 0.4);
							}
							.list_item {
								height: 70px;
								text-align: center;
								@include flex-box(center, center);
								&:nth-child(1) {
									width: 62px;
									margin-right: 2px;
								}
								&:nth-child(2) {
									width: 175px;
									margin: 0 2px;
								}
								&:nth-child(3) {
									width: 175px;
									margin: 0 2px;
								}
								&:nth-child(4) {
									width: 145px;
									margin: 0 2px;
								}
								&:nth-child(5) {
									width: 206px;
									margin: 0 2px;
								}
								&:nth-child(6) {
									width: 176px;
									margin: 0 2px;
								}
								&:nth-child(7) {
									width: 175px;
									margin-left: 2px;
								}
								.select {
									width: 20px;
									height: 20px;
									border: 1px solid #65a6dd;
									border-radius: 2px;
									cursor: pointer;
									@include prefixCss3(transition, border-color 0.2s);
									&:hover {
										border-color: #409eff;
									}
									&.active {
										background-color: #409eff;
										border-color: #409eff;
										&::after {
											content: '';
											display: block;
											width: 100%;
											height: 100%;
											@include set-bg-img('../../../assets/images/icon-yes.png');
										}
									}
								}
								span {
									width: 100%;
									cursor: pointer;
									overflow: hidden;
									text-overflow: ellipsis;
									white-space: nowrap;
								}
							}
						}
					}
				}
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/views/PerBlackMenu/perBlackMenuDefault/index.vue